<template>
  <div>
    <div class="container">
      <div class="flex justify-end pt-2">
        <a href="/" class="px-2 hover:text-dbm-red">English</a> |
        <a href="/bm" class="px-2 hover:text-dbm-red">Bahasa Malaysia</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>